import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const inviteUsers: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_AUTH_API}/invite-users`),
};

export default inviteUsers;
